import { computed } from 'vue'
import DynamicPageUtils from '@/shared/utils/dynamicPageUtils.js'

function useTheme() {
  return DynamicPageUtils.getTheme()
}

export function infoBlockTheme(variant = 'default') {
  const theme = useTheme()
  return computed(
    () => theme.infoBlock?.[variant] || theme.infoBlock?.default || {},
  )
}

export function sectionBlockTheme(variant = 'default') {
  const theme = useTheme()
  return computed(
    () => theme.sectionBlock?.[variant] || theme.sectionBlock?.default || {},
  )
}

export function groupBlockTheme(variant = 'default') {
  const theme = useTheme()
  return computed(
    () => theme.groupBlock?.[variant] || theme.groupBlock?.default || {},
  )
}

export function buttonGroupBlockTheme(variant = 'default') {
  const theme = useTheme()
  return computed(
    () =>
      theme.buttonGroupBlock?.[variant] ||
      theme.buttonGroupBlock?.default ||
      {},
  )
}

export function checkListBlockTheme(variant = 'default') {
  const theme = useTheme()
  return computed(
    () =>
      theme.checkListBlock?.[variant] || theme.checkListBlock?.default || {},
  )
}

export function buttonClass(variant = 'default') {
  const theme = useTheme()
  return computed(
    () => theme.buttons?.[variant] || theme.buttons?.default || '',
  )
}
